export default {
  label: {
    title: 'Search',
    search: 'Text search in posts',
    tags: 'Select tags',
    send: 'Send',
    clear: 'Clear',
    requiredValue: 'Value required',
    trashLabel: 'Clear filter',
    closeLabel: 'Close information',
    filterLabel: 'Apply filter',
    tooltip: {
      filterButton: 'Filters',
    },
    rule: 'Must contain at least two characters',
  },

  titles: {
    postedAt: 'Document Date: ',
    tags: 'Classifications: ',
    text: 'Document Text: ',
  },

  infoLabel: 'Form Information',
  closeLabel: 'Close Information',
  filter: 'Filter',
  noPosts: 'No results found for the selected filter',
  viewLabel: 'View document',
  searchTip: 'Use boolean operators AND, OR, NOT to combine multiple terms. For phrases, use quotation marks("").</br>Parentheses can be used to group expressions. Ex: (car OR trucks) AND red.',

  faq: {
    title: 'What is it?',
    description: 'Form for searching and viewing the desired documents based on the text entered by the user.',
  },
  faq2: {
    title: 'How to use it?',
    description: 'Enter the desired word or phrase and press the search button.',
  },
  faq3: {
    title: 'How to reset the form?',
    description: 'To clear the form, click the clear button. When an import is successful, the form resets automatically.',
  },
  faq4: {
    title: 'What happens if the import fails?',
    description: 'If an import fails, an error message will be displayed. Reset the form, check the information, and try again.',
  },
};
